import $ from 'jquery'

export class StorylaneApp {
  constructor() {
    let $linksStorylane = $('[data-storylane-url]');

    if ($linksStorylane.length === 0) {
      return;
    }

    let script = document.createElement('script');

    script.type = 'text/javascript'
    script.src = 'https://js.storylane.io/js/v1/storylane.js'
    script.async = true
    script.onload = this.onLoad.bind(this)

    document.head.appendChild(script)
  }

  onLoad() {
    $('body').on('click', '[data-storylane-url]', this.onClickLink.bind(this))
  }

  onClickLink(e) {
    e.preventDefault()
    e.stopPropagation()

    let url = $(e.currentTarget).data('storylane-url')
    let width = $(window).width()
    let height = $(window).height()

    Storylane.Play({
      type: 'popup',
      demo_type: 'image',
      width: width,
      height: height,
      scale: '0.95',
      demo_url: url,
      padding_bottom: 'calc(65.86% + 25px)'
    })
  }
}
